import { create } from 'zustand';

interface UpdateCompletionDateModalProps {
  show: boolean;
  data: {
    uid?: string;
    memo?: string;
    completionDate?: Date;
  };
  open: (data: { uid: string; memo?: string; completionDate?: Date }) => void;
  close: () => void;
}

const useUpdateCompletionDateModalStore = create<UpdateCompletionDateModalProps>((set) => ({
  show: false,
  data: {},
  open: (data) => {
    set({ data: data, show: true });
  },
  close: () => {
    set({ show: false });
  },
}));

export default useUpdateCompletionDateModalStore;
